export const transformToMessengerPayload = (data) => {
  let messengerProfileValues = {};
  if (data.get_started) {
    messengerProfileValues.get_started = {
      payload: JSON.stringify({ type: 'convnodeid', data: data.get_started })
    };
  }
  if (data.greeting) {
    messengerProfileValues.greeting = [
      {
        locale: 'default',
        text: data.greeting
      }
    ];
  }
  if (data?.call_to_actions?.length > 0) {
    messengerProfileValues.persistent_menu = [
      {
        locale: 'default',
        composer_input_disabled: false,
        call_to_actions: data.call_to_actions.map(action => ({
          type: action.type.toLowerCase(),
          title: action.title,
          ...(action.type === 'POSTBACK'
            ? { payload: JSON.stringify({ type: 'convnodeid', data: action.data }) }
            : { url: action.url, webview_height_ratio: 'full' })
        }))
      }
    ];
  }
  return messengerProfileValues;
};

export const transformDeleteMessengerPayload = (currentProfile, newProfile) => {
  const fields = [];
  const { get_started, greeting, persistent_menu } = currentProfile?.data?.length > 0 ? currentProfile.data[0] : [] ;
  if (get_started && !newProfile.get_started) {
    fields.push('get_started');
  }
  if (greeting && !newProfile.greeting) {
    fields.push('greeting');
  }
  if (persistent_menu && newProfile.call_to_actions.length === 0) {
    fields.push('persistent_menu');
  }
  return fields.length > 0 ? { fields: fields } : {};
};
